import type { AnyObj } from '@/types';

function calculateDimensions(width: number): { width: number; height: number } {
  const aspectRatio = 300 / 650;
  const height = Math.round(width / aspectRatio);
  return { width, height };
}

export default {
  remote: (imgName: string, suffix?: string) => {
    return `https://cdn.s3.mall.startcatcher.com/public/${imgName}.${suffix ?? 'png'}`;
  },
  getHotZone: (hotZoneList: AnyObj[], consultImgObject: AnyObj) => {
    let hitZoneList: AnyObj[] = [];

    if (!hotZoneList?.length || !consultImgObject) return hitZoneList;

    for (let i = 0; i < hotZoneList.length; i++) {
      const item = hotZoneList[i];
      // x实际宽度
      const factX = item.endPointAxisX - item.startAxisX;
      // 宽度绘制比例
      const xRatio = `${((factX / consultImgObject.width) * 100).toFixed(2)}%`;

      // y实际宽度
      const factY = item.endPointAxisY - item.startAxisY;
      // 高度绘制比例
      const yRatio = `${((factY / consultImgObject.height) * 100).toFixed(2)}%`;

      // 距离元素左边的绘制比例
      const lRatio = `${((item.startAxisX / consultImgObject.width) * 100).toFixed(2)}%`;
      // 距离元素上边的绘制比例
      const tRatio = `${((item.startAxisY / consultImgObject.height) * 100).toFixed(2)}%`;

      hitZoneList.push({
        _source: { ...item, ...consultImgObject },
        xRatio,
        yRatio,
        lRatio,
        tRatio,
      });
    }

    return hitZoneList;
  },
  /**
   * 生成随机宽度的图片；比例300:650
   * @param width
   * @returns
   */
  getRandom(width = 300) {
    const dimensions = calculateDimensions(width);
    return `https://picsum.photos/${dimensions.width}/${dimensions.height}.webp`;
  },
  getMock(width = 200, height?: number) {
    return `https://dummyimage.com/${width}x${height || width}/ef6348/fff`;
  },
  reviseRichTextImg(richText: string) {
    return richText
      ?.replace(
        /<img/g,
        `<img style="max-width: 100% !important; width: 100% !important; height: auto !important; display: block;"`
      )
      ?.replace(/<\/?figure[^>]*>/g, '');
  },
};
